<template>
    <section class="">
        <b-row>
            <b-col cols="12" lg="12">
                <b-form-group
						label="Aeropuertos"
					>
						<multiselect
							v-model="filters.airports"
							:options="airportsOpts"
							group-label="group"
							group-values="options"
							group-select
							multiple
							label="text"
							track-by="value"
							placeholder="Todos"
							:option-height="10"
							taggable
						>
							<template v-slot:clear >
								<div class="multiselect__clear" @click="filters.airport = []"></div>
							</template>
						</multiselect>
					</b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col >
                <b-button @click="search">Buscar</b-button>
            </b-col>
        </b-row>
       <br>
        <section class="" v-if="!$root.isEmpty(data)">
            <b-tabs content-class="mt-3">
                <!-- Loop through each airport (IATA) -->
                <b-tab
                v-for="(nodeAirport, _i) in data"
                :key="_i"
                :title="nodeAirport.iata"
                >
                <!-- Loop through each flight in the airport's flightsDelayed array -->
                <b-card v-for="(flightItem, index) in nodeAirport.data" :key="index" class="mb-3 mt-1" >
                        <template #header>
                            <a :href="flightItem.url" target="_BLANK"> 
                                <md-icon v-if="flightItem.tripType=='A2H'" icon="flight_land"></md-icon>
                                <md-icon v-else icon="flight_take_off"></md-icon>
                                {{ flightItem.flightStatus.carrierFsCode}} - {{ flightItem.flightStatus.flightNumber }}  ({{flightItem.tripType}}) 
                            </a>
                            <small>{{ flightItem.flightStatus.departureAirportFsCode}} => {{ flightItem.flightStatus.arrivalAirportFsCode}} </small>
                            <b-badge variant="primary" class="float-right">{{ getFlightStatusTag(flightItem.flightStatus) }}</b-badge>
                           
                        </template>

                        <b-card-body>
                            <div class="text-center">
                                <div>
                                    <h5 class="mb-0">Delays:</h5>
                                    <small v-html="formatDelays(flightItem.flightStatus.delays)"></small>
                                </div>
                                
                                <b-card class="text-center">
                                    <b-row>
                                        <b-col v-if="!$root.isEmpty(flightItem.publishedDate)">
                                            <h5 class="mb-0">Published Time</h5>
                                            <b-badge variant="secondary" class="badge-hour" v-b-tooltip.hover :title="formatDateNode(flightItem.publishedDate,'hh:mm A').browser">
                                                {{ formatDateNode(flightItem.publishedDate,'MMM DD, hh:mm A').local }}
                                            </b-badge>
                                        </b-col>
                                        <b-col v-if="!$root.isEmpty(flightItem.newTime)">
                                            <h5 class="mb-0">New Time</h5>
                                            <b-badge variant="secondary" class="badge-hour" v-b-tooltip.hover :title="formatDateNode(flightItem.newTime,'hh:mm A').browser">
                                                {{ formatDateNode(flightItem.newTime,'MMM DD, hh:mm A').local }}
                                            </b-badge>
                                        </b-col>
                                    </b-row>
                                </b-card>


                                <b-button
                                v-b-toggle="'collapse-' + index"
                                variant="info"
                                class="mb-0 mt-2"
                                size="sm"
                                >
                                Rides afectados:  <b-badge>{{flightItem.rides.length}}</b-badge>
                                </b-button>
                            </div>
                          
                            <!-- Collapse body to show flight details -->
                            <b-collapse :id="'collapse-' + index" class="mt-2" show>
                                
                                <!-- Card Service -->
                                <b-card v-for="(ride, __index) in  flightItem.rides" :key="__index" 
                                    class="mb-3" 
                                    :class="{ 'striped': __index % 2 !== 0 }">
                                    <b-row class="container p-3">
                                        <b-col class="col-12 col-md-6">
                                            <p class="text-secondary">
                                                <b-badge  variant="default" v-if="ride.reservation.operatedBy === 'sc'"> <ScIcon />Venta de Shuttle Central</b-badge>
                                                <b-badge  variant="default" v-else><md-icon icon="home" /> <strong> Servicio propio</strong></b-badge>
                                            </p>
                                            <div class="text-muted small-text" v-if="!$root.isEmpty(ride.salesChannel)">
                                                {{ ride.salesChannel.name }}
                                            </div>
                                        </b-col>
                                        <b-col class="col-12 col-md-6">
                                            <p class="text-right mr-3 text-primary"><md-icon :icon="tripIcon(ride)"/>
                                                <a href="#" @click.prevent="openReservation(ride)" class="text-primary">{{ ride.serviceNumber }}</a>
                                                <span v-if="!$root.isEmpty(ride.internalReference)">| {{ ride.internalReference }}</span>
                                                | <b-badge :variant="getVariantBystatus(ride.status)" class="text-uppercase">{{ ride.status }}</b-badge>
                                            </p>
                                            <div class="text-right text-muted small-text" v-if="!$root.isEmpty(ride.supplier)">
                                                Operado por: {{ ride.supplier.name }}
                                                <b-badge :variant="iconSupplierConfirmation(ride.supplierConfirmation).class">
                                                    <md-icon
                                                        :icon="iconSupplierConfirmation(ride.supplierConfirmation).icon"
                                                    />
                                                </b-badge>
                                            </div>
                                        </b-col>
                                    </b-row>

                                    <!-- Tags -->
                                    <div v-if="!$root.isEmpty(ride.tags)">
                                        <b-badge variant="primary" class="mr-1" v-for="(tag,index) in ride.tags" :key="index">
                                            {{tag.text}}
                                        </b-badge>
                                    </div>

                                    <!-- Driver and Vehicle Info -->
                                    <b-row class="mt-2 align-items-center">
                                        <b-col class="col-12 col-md-6">
                                            <div class="mb-0 d-flex justify-content-between">
                                                <p><b>Conductor: </b></p>
                                                <div>
                                                <p>{{ getDriverFromRide(ride) }}                                 
                                                        <b-badge 
                                                            variant="primary" 
                                                            v-b-tooltip.hover title="Tarjeta de Identificación Aeroportuaria"
                                                            v-if="hasDriver(ride) && ride.driver.tia == true">
                                                            TIA
                                                        </b-badge>
                                                    </p>
                                                </div>
                                            </div>
                                        </b-col>
                                        <b-col class="col-12 col-md-6">
                                            <p class="mb-0 d-flex justify-content-between">
                                                <b class="text-sm">Unidad:</b> {{ getUnitFromRide(ride) }} 
                                            </p>
                                        </b-col>
                                    </b-row>

                                    <b-row>
                                        <b-col class="col-12 col-md-6">
                                            <p class="d-flex justify-content-between">
                                                <b>Nombre cliente:</b> 
                                                <span>{{ ride.reservation.client.firstName }}  {{ ride.reservation.client.lastName }}</span>
                                            </p>
                                        </b-col>
                                        <b-col class="col-12 col-md-6">
                                            <p class="d-flex justify-content-between">
                                                <b>Número de vuelo:</b> 
                                                <span>
                                                    <strong>{{ ride.flightNumber }} </strong>
                                                    <md-icon icon="flight" class="text-secondary"></md-icon>
                                                </span>
                                            </p>
                                        </b-col>
                                    </b-row>

                                    <!-- Fechas y horarios pickup y vuelo -->
                                    <b-row>
                                        <b-col class="col-12 col-md-6">
                                            <p class="d-flex justify-content-between">
                                                <b>Fecha y hora de pickup:</b> 
                                                <span>{{ ride.pickupDatetime }} Hrs.</span>
                                            </p>
                                        </b-col>
                                        <b-col class="col-12 col-md-6" v-if="ride.flightDatetime">
                                            <p class="d-flex justify-content-between">
                                                <b>Fecha y hora de vuelo:</b> 
                                                <span>{{ ride.flightDatetime}} Hrs.</span>
                                            </p>
                                        </b-col>
                                    </b-row>

                                    <b-row>
                                        <b-col class="col-12 col-md-6">
                                            <p class="d-flex justify-content-between">
                                                <b>Origen:</b>
                                                <span>{{ ride.pickup.name }}<md-icon class="text-danger" icon="place"/></span>
                                            </p>
                                        </b-col>
                                        <b-col class="col-12 col-md-6">
                                            <p class="d-flex justify-content-between">
                                                <b>Destino:</b>
                                                <span>{{ ride.dropoff.name }}<md-icon class="text-danger" icon="place"/></span>
                                            </p>
                                        </b-col>
                                    </b-row>
                                </b-card>
                            </b-collapse>
                        </b-card-body>
                    </b-card>
                    
                </b-tab>
            </b-tabs>
        </section>
        <section v-else>
            No hay información para mostrar
        </section>
       
        <b-overlay :show="loading" no-wrap></b-overlay>
        <FormReservation
			:model-id="resMod.modelId"
			:copy-from-id="resMod.modelId"
			:formTypeWork="'viewForm'"
			@changeId="resMod.modelId = $event"
			v-model="resMod.show"
		/>
         
    </section>
</template>
  
  <script>
import Multiselect from "vue-multiselect";
import FormReservation from "@/components/sections/reservation/formReservation/index";
import moment from 'moment';

export default {
    name: 'AssignmentTool',
    components: {Multiselect,FormReservation},
    props: {
		ridesSelected: {
			type: Array,
			required: false
		},
        massiveAssignmenItems:{
			type: Array,
			required: false
		}
	},
    data() {
        return {
            loading: false,
            data:[],
            resMod:{
                modelId:-1,
                show:false
            },
            filters:{
                airports:[]
            }
        };
    },
    computed:{
        airportsOpts() {
			return [
				{
					group: "SELECT ALL",
					options: this.$root.auxVars.airportsOpts
				}
			];
		},

    },
    methods: {
        async getFlightStatus(){
            try{
                let params={
                    airports:this.filters.airports
                }
                const response = await this.$root.api
                .post(`flights/status/rides`,params)
                return response.data;
            }catch(error){
              
                const errorMessage = error.response?.data?.error || error.message || "An unexpected error occurred";
                console.log(errorMessage);
                this.$root.showAlert(errorMessage,{variant:'warning'})
                //console.error('Error fetching rides:', error);
                return []; // Return an empty array in case of error
            }
        },
        async search(){
            try{
                if(this.$root.isEmpty(this.filters.airports)) throw "Supplier is required";
            }catch(err){
                this.$root.showAlert(err,{variant:'warning'})
                return;
            }
            
            this.loading = true;
            this.data = await this.getFlightStatus()
            this.loading=false;
        },
        
        formatDelays(delayNode) {
            let departureMessage = '';
            let arrivalMessage = '';

            // Format departure delays
            if (delayNode.departureGateDelayMinutes > 0) {
                departureMessage += `Gate: <span class='text-danger'>+${delayNode.departureGateDelayMinutes}m</span>`;
            }
            if (delayNode.departureRunwayDelayMinutes > 0) {
                if (departureMessage) departureMessage += ' | ';
                departureMessage += `Runway: <span class='text-danger'>+${delayNode.departureRunwayDelayMinutes}m</span>`;
            }
            if (!departureMessage) {
                departureMessage = 'On Time';
            }

            // Format arrival delays
            if (delayNode.arrivalGateDelayMinutes > 0) {
                arrivalMessage += `Gate: <span class='text-danger'> +${delayNode.arrivalGateDelayMinutes}m</span>`;
            }
            if (delayNode.arrivalRunwayDelayMinutes > 0) {
                if (arrivalMessage) arrivalMessage += ' | ';
                arrivalMessage += `Runway: <span class='text-danger'>+${delayNode.arrivalRunwayDelayMinutes}m</span>`;
            }
            if (!arrivalMessage) {
                arrivalMessage = 'On Time';
            }

            // Combine messages for departure and arrival
            return `<div><b>Departure</b>:${departureMessage}</div> <div><b>Arrival:</b> ${arrivalMessage}</div>`;
        },
        openReservation(rideModel) {
			this.resMod.modelId   = rideModel.reservationId,
			this.resMod.show = true;
		},
        tripIcon(rideModel) {
			if (rideModel.pickup.isAirport) return "flight_land";
			//A2H
			else if (rideModel.dropoff.isAirport) return "flight_takeoff";
			//H2A
			else return "place"; //P2P
		},
        iconSupplierConfirmation(status) {
            let icon = "";
            let classe = "";
            switch (status) {
                case "pending":
                    icon = "warning";
                    classe = "warning";
                    break;
                case "confirmed":
                    icon = "check_circle";
                    classe = "success";
                    break;
                case "rejected":
                    icon = "dangerous";
                    classe = "danger";
                    break;
            }
            return { icon: icon, class: classe };
        },
        getDriverFromRide(ride){
            if(this.$root.isEmpty(ride.driver)) return '--';
            return ride.driver.firstName+" "+ride.driver.lastName
        },
        getUnitFromRide(ride){
            if(this.$root.isEmpty(ride.transportUnit)) return '--';
            return ride.transportUnit.title;
        },  
        hasDriver(ride) {
            if (!this.$root.isEmpty(ride.driver)) return true
            return false;
        },
        getVariantBystatus(status){
			try{
				let variant = this.$root.auxVars.transportServiceStatusOpts.find((el)=>{
					return el.value==status
				});
				if(variant) return variant.class;
			}catch(err){console.log(err)}
			return "info";
		},
        formatDateNode(dateNode,format='MMM DD, YYYY hh:mm A') {
            if (!dateNode || !dateNode.dateUtc || !dateNode.dateLocal) {
                throw new Error("Invalid date node format.");
            }

            const { dateUtc, dateLocal } = dateNode;
            // Convert UTC to user's browser local time
            const browserTime = moment(dateUtc).local().format(format);

            return {
                utc: moment(dateUtc).format(format) + ' UTC',
                local: moment(dateLocal).format(format) + ' Local',
                browser: browserTime + ' Browser Time',
            };
        },
        getFlightStatusTag(flightData) {
            console.log(flightData)
            if (!flightData || !flightData.status) {
                return "Unknown Status";
            }

            switch (flightData.status) {
                case "A": // Active
                return "In Air";
                case "S": // Scheduled
                return "Scheduled";
                case "L": // Landed
                return "Landed";
                case "D": // Diverted
                return "Diverted";
                case "C": // Cancelled
                return "Cancelled";
                case "R": // Redirected
                return "Redirected";
                case "DN": // Data Needed
                return "Data Needed";
                default:
                return "Unknown Status";
            }
        },
       
       
    },
    mounted(){
        this.$root.auxVars.loadResourcesOpts({
			vm: this,
			resourceNames: ["suppliersOpts"]
		});
    }
  };
  </script>
<style scoped>
    >>>.card-body{
        padding: 5px !important;
    }
    p{
        margin: 0.5px;
        font-size: smaller;
    }
    .card{
        border-radius: 1.5rem !important;
    }
    >>>label{
        margin-bottom: unset !important;
    }

    .selected .card {
        background-color: blue;
        color: white;
    }
    .status-summary {
        cursor: pointer;
    }
    .badge-hour {
        font-size: 1rem;
        padding: 0.5em 1em;
        background-color: black;
    }
</style>

  